// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Xn-z","slideIn":"Yn-z"};